document.addEventListener('DOMContentLoaded', () => {
    'use strict'


    // ACTIVE LINK
    const currentUrl = window.location.href;
    const navLinks = document.querySelectorAll('.menu-nav-header a');

    navLinks.forEach(link => {
        if (link.href === currentUrl) {
            link.classList.add('active');

            // Check if the active link has a parent dropdown menu
            const dropdownMenu = link.closest('.dropdown-menu');
            if (dropdownMenu) {
                // Add active class to parent dropdown toggle
                const dropdownToggle = dropdownMenu.previousElementSibling;
                dropdownToggle.classList.add('active');
            }
        }
    });

    // TOOLTIPS
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

    // SWIPER
    var swiper = new Swiper(".swiperCourse", {
        slidesPerView: 'auto',
        spaceBetween: 0,
        freeMode: true,
        pagination: {
            clickable: true,
        },
    });

    var swiper = new Swiper(".swiperBanner", {
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });

    var swiper = new Swiper(".swiperStories", {
        pagination: {
            el: ".swiper-pagination",
            dynamicBullets: true,
        },
        autoplay: {
            delay: 5000,
        }
    });

    // FIXED HEADER
    // FIXED HEADER
    const header = document.querySelector('.main-navigation');

    if (header) {
        window.addEventListener('scroll', function () {
            if (window.pageYOffset >= 250) {
                header.classList.add('scrolled');
            } else {
                header.classList.remove('scrolled');
            }
        });
    }


    //DROPDOWN
    // var Select = document.querySelectorAll(".dropdown-select");
    // Select.forEach(function (select) {
    //     NiceSelect.bind(select);
    // });

    // Select all .dropdown-select elements
    var selects = document.querySelectorAll(".dropdown-select");
    selects.forEach(function (select) {
        NiceSelect.bind(select);

        var options = select.querySelectorAll("option");

        options.forEach(function (option) {
            var regionValue = option.getAttribute("data-region");
            var dropdownOption = select.nextElementSibling.querySelector('.option[data-value="' + option.value + '"]');
            dropdownOption.setAttribute("data-region", regionValue);
        });
    });





    //STICKY SHARE
    var sticky = new Sticky('.sticky');


    //- SHADOW BG
    const body = document.querySelector('body');
    const dropdownToggles = document.querySelectorAll('.dropdown-toggle');

    function checkDropdownOpen() {
        if (document.querySelector('.dropdown-toggle.show')) {
            body.classList.add('dropdown-open');
        } else {
            body.classList.remove('dropdown-open');
        }
    }

    dropdownToggles.forEach(dropdownToggle => {
        dropdownToggle.addEventListener('click', () => {
            setTimeout(checkDropdownOpen, 1);
        });
    });

    document.addEventListener('click', checkDropdownOpen);


    // DATEPICKER
    const inputElements = document.querySelectorAll('.date-picker input');
    inputElements.forEach(function (elem, index) {
        const datepicker = new Datepicker(elem, {
            buttonClass: 'btn',
            clearButton: true,
            todayButton: true,
            autohide: true,
            language: 'ar',
            nextArrow: "",
            prevArrow: ""
        });
    });

    //UPLOAD FILE
    // FILEPOND - UPLOAD FILES
    FilePond.registerPlugin(
        FilePondPluginFileValidateType,
        FilePondPluginFileValidateSize,
        FilePondPluginImagePreview,
        FilePondPluginImageResize,
        FilePondPluginImageTransform
    );

    FilePond.setOptions({
        labelIdle: `اسحب الملف هنا أو <span class="filepond--label-action">تصفح من جهازك</span>`,
        labelInvalidField: 'الحقل يحتوي على ملفات غير صالحة',
        labelFileWaitingForSize: 'بانتظار الحجم',
        labelFileSizeNotAvailable: 'الحجم غير متاح',
        labelFileLoading: 'بالإنتظار',
        labelFileLoadError: 'حدث خطأ أثناء التحميل',
        labelFileProcessing: 'يتم الرفع',
        labelFileProcessingComplete: 'تم الرفع',
        labelFileProcessingAborted: 'تم إلغاء الرفع',
        labelFileProcessingError: 'حدث خطأ أثناء الرفع',
        labelFileProcessingRevertError: 'حدث خطأ أثناء التراجع',
        labelFileRemoveError: 'حدث خطأ أثناء الحذف',
        labelTapToCancel: 'انقر للإلغاء',
        labelTapToRetry: 'انقر لإعادة المحاولة',
        labelTapToUndo: 'انقر للتراجع',
        labelButtonRemoveItem: 'مسح',
        labelButtonAbortItemLoad: 'إلغاء',
        labelButtonRetryItemLoad: 'إعادة',
        labelButtonAbortItemProcessing: 'إلغاء',
        labelButtonUndoItemProcessing: 'تراجع',
        labelButtonRetryItemProcessing: 'إعادة',
        labelButtonProcessItem: 'رفع',
        labelMaxFileSizeExceeded: 'الملف كبير جدا',
        labelMaxFileSize: 'حجم الملف الأقصى: {filesize}',
        labelMaxTotalFileSizeExceeded: 'تم تجاوز الحد الأقصى للحجم الإجمالي',
        labelMaxTotalFileSize: 'الحد الأقصى لحجم الملف: {filesize}',
        labelFileTypeNotAllowed: 'ملف من نوع غير صالح',
        fileValidateTypeLabelExpectedTypes: 'تتوقع {allButLastType} من {lastType}',
        imageValidateSizeLabelFormatError: 'نوع الصورة غير مدعوم',
        imageValidateSizeLabelImageSizeTooSmall: 'الصورة صغير جدا',
        imageValidateSizeLabelImageSizeTooBig: 'الصورة كبيرة جدا',
        imageValidateSizeLabelExpectedMinSize: 'الحد الأدنى للأبعاد هو: {minWidth} × {minHeight}',
        imageValidateSizeLabelExpectedMaxSize: 'الحد الأقصى للأبعاد هو: {maxWidth} × {maxHeight}',
        imageValidateSizeLabelImageResolutionTooLow: 'الدقة ضعيفة جدا',
        imageValidateSizeLabelImageResolutionTooHigh: 'الدقة مرتفعة جدا',
        imageValidateSizeLabelExpectedMinResolution: 'أقل دقة: {minResolution}',
        imageValidateSizeLabelExpectedMaxResolution: 'أقصى دقة: {maxResolution}',
        storeAsFile: true,

    });

    const FILEPOND_ITEMS = document.querySelectorAll('input[type="file"]');
    Array.from(FILEPOND_ITEMS).forEach(FILEPOND_ITEMS => {
        FilePond.create(FILEPOND_ITEMS);
    });

    //TOAST
    const toastTrigger = document.getElementById('liveToastBtn')
    const toastLiveExample = document.getElementById('liveToast')

    if (toastTrigger) {
        const toastBootstrap = bootstrap.Toast.getOrCreateInstance(toastLiveExample)
        toastTrigger.addEventListener('click', () => {
            toastBootstrap.show()
        })
    }


    // Initialize Choices.js for each element with the "mySelect" class
    const selectElements = document.querySelectorAll('.dropdown-multiSelect');
    selectElements.forEach((selectElement) => {
        new Choices(selectElement, {
            removeItemButton: true,
            placeholder: true,
            loadingText: 'تحميل...',
            placeholderValue: 'حدد الاختيارات',
            noResultsText: 'لم يتم العثور على نتائج',
            noChoicesText: 'لا توجد خيارات للاختيار من بينها',
            itemSelectText: 'اضغط للتحديد',
            uniqueItemText: 'يمكن إضافة القيم الفريدة فقط',
            customAddItemText: 'يمكن إضافة القيم المطابقة لشروط معينة فقط',
            addItemText: (value) => {
                return `اضغط على Enter للإضافة <b>"${value}"</b>`;
            },
            maxItemText: (maxItemCount) => {
                return `فقط ${maxItemCount} يمكن إضافة القيم`;
            },
            valueComparer: (value1, value2) => {
                return value1 === value2;
            },

        });
    });



    const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
    const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl))


});
